export default __webpack_public_path__ + "locales/tr/InviteDialog.json?hash=8a5865b12e7744b806a88788c59b71dd";